import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.9994 10.0005L5 15.0004M9.9994 10.0005L15 15.001M9.9994 10.0005L5 5.0012M9.9994 10.0005L15 5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgClose;
